
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.273 20.045H5.727M15.546 25.773H5.726M18.818 14.318H5.728M25.364 8.59H5.727","stroke":"#494949","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M31.09 23.35a5.05 5.05 0 01-1.202 1.957 5.24 5.24 0 01-7.41 0 5.217 5.217 0 01-.893-1.2","stroke":"#3084B9","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M30.783 19.098a5.25 5.25 0 00-.893-1.2 5.24 5.24 0 00-7.41 0 5.076 5.076 0 00-1.207 1.957","stroke":"#D07D01","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M28.772 19.1h2.314v-2.317","stroke":"#D07D01","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M23.595 24.11h-2.314v2.315","stroke":"#3084B9","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    